/** Wire a trigger button to a dropdown: click toggles, outside click and Escape dismiss. */
export function dropdown(trigger: HTMLButtonElement, menu: HTMLElement, signal: AbortSignal): void {
  const close = () => {
    menu.hidden = true;
    trigger.ariaExpanded = "false";
    document.removeEventListener("click", close);
  };
  trigger.ariaHasPopup = "menu";
  trigger.ariaExpanded = "false";
  menu.hidden = true;
  trigger.addEventListener("click", () => {
    if (!menu.hidden) return close();
    menu.hidden = false;
    trigger.ariaExpanded = "true";
    // The opening click is still bubbling; only later clicks should dismiss the menu.
    setTimeout(() => document.addEventListener("click", close, { once: true }));
  });
  menu.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      close();
      trigger.focus();
    }
  });
  signal.addEventListener("abort", close, { once: true });
}

export function menuItem(label: string, action: () => void, cls = ""): HTMLButtonElement {
  const button = <button class={cls} type="button" role="menuitem">{label}</button>;
  button.addEventListener("click", action);
  return button as HTMLButtonElement;
}
